import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

@Injectable()
export class ExcelService {
  workbook: ExcelJS.Workbook;
  worksheet: any;
  constructor() { }

  public exportAsExcelFile(
    json: any[],
    excelFileName: string,
    colheaders: any[],
    gdpflag: any,
    downloadFile: boolean = true
  ) {
    const title = excelFileName;

    let newheaders = colheaders.filter(
      item => item !== "Research Comments"
    );

    const header = newheaders;
    const data = json;

    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet("Sheet 1");

    if (gdpflag === true) {

      let firstrow = worksheet.addRow([
        "GDPR alert! - This mandate has personally identifiable information of European Union data subject/s."
      ]);
      firstrow.getCell(1).font = {
        name: "Arial",
        color: { argb: "ff0000" },
        family: 2,
        size: 11,
        bold: true
      };

      worksheet.mergeCells(`A${firstrow.number}:F${firstrow.number}`);
    }

    let headerRow = worksheet.addRow(header);

    headerRow.eachCell((cell, number) => {
      worksheet.getColumn(number).width = 30;
      cell.font = {
        name: "Arial",
        size: 11,
        bold: true
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "f3f3f3" }
      };
    });

    data.forEach(d => {
      let length = d.length;

      if (d[length - 1] === "New") {

        d.pop();
        d[length - 1] = "";
        let row = worksheet.addRow(d);
        row.eachCell((cell, number) => {
          worksheet.getColumn(number).width = 30;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "adbcd2" }
          };
        });
      } else {

        if (d[length - 1] === "Old") {
          d.pop();
        }

        worksheet.addRow(d);
      }
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    return workbook.xlsx.writeBuffer().then(data => {
      let blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      if (downloadFile) {
        saveAs(blob, excelFileName + ".xlsx");
        return null;
      }

      return blob;
    });
  }
}